import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import HomePage from './pages/HomePage';
import AristocratCipher from './pages/AristocratCipher';
import AtbashCipher from './pages/AtbashCipher';
import CaesarCipher from './pages/CaesarCipher';
import VigenereCipher from './pages/VigenereCipher';
import BaconianPractice from './components/BaconianPractice';
import HillCipher from './pages/HillCipher';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#3949ab', // Deep purple-blue
      light: '#6f74dd',
      dark: '#00227b',
    },
    secondary: {
      main: '#7b1fa2', // Purple
      light: '#ae52d4',
      dark: '#4a0072',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#000000',
      secondary: '#666666',
    },
    difficulty: {
      easy: '#00897b',
      medium: '#ff8f00',
      hard: '#d32f2f',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '3rem',
      fontWeight: 700,
      color: '#000000',
    },
    h5: {
      color: '#000000',
      fontWeight: 400,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          background: '#ffffff',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.1)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '1rem',
          padding: '10px 24px',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
          transition: 'all 0.2s ease-in-out',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          fontWeight: 600,
          fontSize: '0.875rem',
          padding: '4px 8px',
        },
        filledSuccess: {
          backgroundColor: '#00897b',
          color: '#ffffff',
        },
        filledWarning: {
          backgroundColor: '#ff8f00',
          color: '#ffffff',
        },
        filledError: {
          backgroundColor: '#d32f2f',
          color: '#ffffff',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/aristocrat" element={<AristocratCipher />} />
          <Route path="/atbash" element={<AtbashCipher />} />
          <Route path="/caesar" element={<CaesarCipher />} />
          <Route path="/vigenere" element={<VigenereCipher />} />
          <Route path="/baconian" element={<BaconianPractice />} />
          <Route path="/hill" element={<HillCipher />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
